import angular from 'angular';
import constants from 'app/constants';
import {
  amDataService,
  loaderService,
  ssDialogService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './edit-preparation-item-category-dialog.controller';
import template from './edit-preparation-item-category-dialog.html';
import validator, { name as validatorName } from '../messages/preparaton-item-category.unique-name.validator.directive';
import nameMessageTpl from '../messages/preparaton-item-category.name.messages.html';


class dialogService {
  getOptions($event, { customerId, preparationItemCategory }) {
    return {
      controller,
      controllerAs: 'editPreparationItemCategoryDialogVM',
      locals: {
        customerId,
        preparationItemCategory
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.auditTrail.editPreparationItemCategoryDialog', [
  alerts,
  amDataService,
  constants,
  loaderService,
  ssDialogService,
])
  .directive(validatorName, validator)
  .service('editPreparationItemCategoryDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('preparaton-item-category.name.messages.html', nameMessageTpl);
  })
  .name;
